  <!-- LISTE DES COMMENTAIRES -->
  <h5 class="mt-4">Commentaires des utilisateurs</h5>
  @if(company.comments && company.comments.length){
    <div class="list-group">

    @for(comment of company.comments; track $index) {
        <div class="list-group-item border-0 border-bottom py-3">
            <!-- <div class=" w-75 mx-auto"> -->
                <small class="text-muted">
                Utilisateur :
                {{ comment.author.firstName }} {{ comment.author.lastName }}

                <!-- Rôle entre parenthèse si l'utilisateur est propriétaire de la company -->
                @for(c of currentUser?.companies; track $index) {
                    @if(c.data._id === company._id) {
                        ({{ c.role }})
                    }
                }
                </small>
                <br>
                <!-- Date + heure -->
                <small class="text-muted">
                {{ comment.createdAt | date:'dd/MM/yyyy à HH:mm' }}
                </small>

                @if(editingComment && editingComment._id === comment._id) {
                    <!-- Si le commentaire est en mode édition -->
                    <textarea class="form-control mb-2" [(ngModel)]="editingComment.message"></textarea>
                    <button class="btn btn-primary btn-sm me-2" (click)="saveComment()">Enregistrer</button>
                    <button class="btn btn-secondary btn-sm" (click)="cancelEdit()">Annuler</button>
                } @else {
                    <!-- Message -->
                    <p class="m-2 border p-2 rounded-3">{{ comment.message }}</p>
                }

                <!-- Bouton modifier si l'auteur == user -->
                @if(comment.author._id === currentUser?._id && !editingComment) {
                <button (click)="editComment(comment)" class="btn btn-outline-primary btn-sm"><i class="bi bi-pencil-square"></i></button>
                    <!-- Supprimer -->
                    <button (click)="deleteComment(comment._id)" class=" mx-2 btn btn-outline-danger btn-sm"><i class="bi bi-trash"></i></button>
                }
            <!-- </div> -->
        </div>
    }

    </div>
  } @else {
    <p class="text-muted">Aucun commentaire pour le moment.</p>
  }